import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared';
import { MenuComponent } from './menu.component';

/**
 * `MenuModule`
 *
 * Embedding <tw-menu> component to the app component
 */
@NgModule({
    imports: [SharedModule],
    declarations: [MenuComponent],
    exports: [MenuComponent]
})
export class MenuModule {
}



// WEBPACK FOOTER //
// ./src/app/components/menu/menu.module.ts